import StandardSelect from './StandardSelect';

export default StandardSelect;